import { render } from "./news_slider.vue?vue&type=template&id=359c3f3c"
import script from "./news_slider.vue?vue&type=script&lang=js"
export * from "./news_slider.vue?vue&type=script&lang=js"

import exportComponent from "/home/thedrago/public_html/NewSite2023/wp-content/themes/chop-child/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/components/news_slider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "359c3f3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('359c3f3c', __exports__)) {
    api.reload('359c3f3c', __exports__)
  }
  
  module.hot.accept("./news_slider.vue?vue&type=template&id=359c3f3c", () => {
    api.rerender('359c3f3c', render)
  })

}


export default __exports__